<template>
    <div>Email: art crankedup.com</div>
</template>

<script setup>
</script>

<style>
</style>